import { AbstractPreset, config } from "./AbstractPreset";

export default class RectangleNoneGrid extends AbstractPreset {
	getName(): string {
		return 'rectangleNoneGrid';
	}

	getConfig(): config {
		return {
			"base": {
				"shape": "rectangle",
				"presetShape": this.getName(),
				"primitives": {
					"width": 50,
					"length": 50
				},
			},
			"drillholes": {
				"type": "grid",
				"amountHorizontal": 5,
				"amountVertical": 5,
				"offset": 30,
				"diameter": 20
			},
			"cutouts": [],
		};
	}

}
